import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage.tsx';
import {useVerifiedPermissions} from '../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../config/rbac/actions.ts';

// FNP-861: READ-ONLY module — index and detail only. No add or edit route.
export const SyntheticUsersLayout = () => {

    const {allowedActions} = useVerifiedPermissions();

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListSyntheticUsers) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetSyntheticUser) ? (
                        <DetailPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
        </Routes>
    );
};
